import { type AxiosResponse } from 'axios';

export default function handleData<Response>(
  response?: AxiosResponse<Response>,
): Response | null {
  if (!response || (response && typeof response.data === 'undefined')) {
    return null;
  }

  /**
   * response.data here refers to the data object returned from the axios
   * response and not the data object that we get from the API.
   */
  return response.data;
}
